// extracted by mini-css-extract-plugin
export default {"slot-btn":"SlotButton_slot-btn__u+eK3","active":"SlotButton_active__cXRq9"};